// extracted by mini-css-extract-plugin
module.exports = {"menuPosition":"NavBar_menuPosition__Ko51G","menuBackground":"NavBar_menuBackground__3o1Bx","center":"NavBar_center__3DqCP"};